import React from 'react';
import { SvgIcon } from '@mui/material';

const HeadphonesIcon = React.forwardRef((props, ref) => {
	const { sx, ...other } = props;
	
	return (
		<SvgIcon
			ref={ref}
			viewBox="0 0 16 16"
			sx={sx}
			{...other}
		>
			<g clipPath="url(#clip0_1821_3699)">
				<path 
					d="M3.42855 7.99961V4.99389C3.43748 4.40307 3.5629 3.81982 3.79763 3.27755C4.03235 2.73529 4.37177 2.24466 4.79644 1.8338C5.2211 1.42294 5.72267 1.09991 6.27239 0.883218C6.82211 0.66653 7.40919 0.560442 7.99998 0.571034C8.59078 0.560442 9.17785 0.66653 9.72758 0.883218C10.2773 1.09991 10.7789 1.42294 11.2035 1.8338C11.6282 2.24466 11.9676 2.73529 12.2023 3.27755C12.4371 3.81982 12.5625 4.40307 12.5714 4.99389V7.99961M10.2857 13.9996C10.8919 13.9996 11.4733 13.7588 11.9019 13.3301C12.3306 12.9015 12.5714 12.3201 12.5714 11.7139V9.14246M10.2857 13.9996C10.2857 14.3785 10.1352 14.7418 9.86728 15.0098C9.59937 15.2777 9.23601 15.4282 8.85713 15.4282H7.14284C6.76396 15.4282 6.4006 15.2777 6.13269 15.0098C5.86478 14.7418 5.71427 14.3785 5.71427 13.9996C5.71427 13.6207 5.86478 13.2574 6.13269 12.9895C6.4006 12.7215 6.76396 12.571 7.14284 12.571H8.85713C9.23601 12.571 9.59937 12.7215 9.86728 12.9895C10.1352 13.2574 10.2857 13.6207 10.2857 13.9996ZM1.71427 6.28532H2.85713C3.00868 6.28532 3.15402 6.34552 3.26119 6.45269C3.36835 6.55985 3.42855 6.7052 3.42855 6.85675V10.2853C3.42855 10.4369 3.36835 10.5822 3.26119 10.6894C3.15402 10.7965 3.00868 10.8567 2.85713 10.8567H1.71427C1.41116 10.8567 1.12047 10.7363 0.906146 10.522C0.691819 10.3077 0.571411 10.017 0.571411 9.71389V7.42818C0.571411 7.12507 0.691819 6.83438 0.906146 6.62006C1.12047 6.40573 1.41116 6.28532 1.71427 6.28532ZM14.2857 10.8567H13.1428C12.9913 10.8567 12.8459 10.7965 12.7388 10.6894C12.6316 10.5822 12.5714 10.4369 12.5714 10.2853V6.85675C12.5714 6.7052 12.6316 6.55985 12.7388 6.45269C12.8459 6.34552 12.9913 6.28532 13.1428 6.28532H14.2857C14.5888 6.28532 14.8795 6.40573 15.0938 6.62006C15.3081 6.83438 15.4286 7.12507 15.4286 7.42818V9.71389C15.4286 10.017 15.3081 10.3077 15.0938 10.522C14.8795 10.7363 14.5888 10.8567 14.2857 10.8567Z" 
					stroke="currentColor"
					strokeWidth="1.14286"
					strokeLinecap="round"
					strokeLinejoin="round"
					fill="none"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1821_3699">
					<rect width="16" height="16" fill="white"/>
				</clipPath>
			</defs>
		</SvgIcon>
	);
});

HeadphonesIcon.displayName = 'HeadphonesIcon';

export default HeadphonesIcon;
